module.exports = __webpack_public_path__ + "static/media/s_v10_20.4c4688d9.mp3";